import { productListLineStyles as styles } from "@solveindustrial/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.selectedCheckbox = {
    ...styles.selectedCheckbox,
    sizeVariant: "default",
};

styles.editNotesLink = {
    ...styles.editNotesLink,
    typographyProps: { size: 12 },
    css: css`
        ${styles.editNotesLink?.css}
        margin-top: 16px;
    `,
};

styles.partNumbersGridItem = {
    ...styles.partNumbersGridItem,
    css: css`
        ${styles.partNumbersGridItem?.css}
        ${mediaQueriesBP.minMD} {
            padding-left: 0;
        }
    `,
};

styles.productPartNumbersStyles = {
    ...styles.productPartNumbersStyles,
    container: {
        ...styles.productPartNumbersStyles?.container,
        css: css`
            ${styles.productPartNumbersStyles?.container?.css}
            padding-left: 0;
        `,
    },

    erpNumberGridItem: {
        ...styles.productPartNumbersStyles?.erpNumberGridItem,
        css: css`
            ${styles.productPartNumbersStyles?.erpNumberGridItem?.css}
            flex-direction: row;
            padding-left: 0;

            ${mediaQueriesBP.maxMD} {
                flex-direction: column;
                align-items: flex-start;
                padding-inline-start: 2px;

                legend,
                span {
                    padding-inline-start: 2px;
                }
            }
        `,
    },

    manufacturerItemGridItem: {
        ...styles.productPartNumbersStyles?.manufacturerItemGridItem,
        css: css`
            ${styles.productPartNumbersStyles?.manufacturerItemGridItem?.css}
            flex-direction: row;
            padding-left: 0;

            ${mediaQueriesBP.maxMD} {
                flex-direction: column;
                align-items: flex-start;
                padding-inline-start: 2px;
                margin-top: 8px;

                legend,
                span {
                    padding-inline-start: 2px;
                }
            }
        `,
    },
};

styles.notesGridItem = {
    ...styles.notesGridItem,
    css: css`
        ${styles.notesGridItem?.css}
        ${mediaQueriesBP.minMD} {
            padding-left: 0;
        }
    `,
};

styles.notesStyles = {
    ...styles.notesStyles,
    heading: {
        ...styles.notesStyles?.heading,
        size: 16,
        weight: 700,
        color: colorStrings.commonGlobalGrayText,
        css: css`
            ${styles.notesStyles?.heading?.css}
            margin-bottom: 4px;
        `,
    },
};

styles.productPriceStyles = {
    ...styles.productPriceStyles,
    priceLabelText: {
        ...styles.productPriceStyles?.priceLabelText,
        transform: "none",
        color: colorStrings.commonGlobalGrayText,
        weight: 700,
        size: 16,
        css: css`
            ${styles.notesStyles?.heading?.css}
            margin-bottom: 0;
        `,
    },
};

styles.productAvailabilityStyles = {
    ...styles.productAvailabilityStyles,
    availabilityByWarehouseLink: {
        ...styles.productAvailabilityStyles?.messageText,
        typographyProps: { size: 12 },
    },
};

styles.productQuantityOrderedStyles = {
    ...styles.productQuantityOrderedStyles,
    labelProps: {
        ...styles.productQuantityOrderedStyles?.labelProps,
        css: css`
            ${styles.productQuantityOrderedStyles?.labelProps?.css}
            ${mediaQueriesBP.minMD} {
                padding: 0;
            }
        `,
    },
};

styles.deleteLink = {
    ...styles.deleteLink,
    typographyProps: { size: 16 },
};

styles.imageGridItem = {
    ...styles.imageGridItem,
    width: [3, 3, 2, 2, 1],
    css: css`
        ${styles.imageGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 1;
            margin-bottom: 16px !important;
        }
    `,
};

styles.descriptionGridItem = {
    ...styles.descriptionGridItem,
    width: [12, 12, 4, 4, 4],
    css: css`
        ${styles.descriptionGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 3;
            span {
                padding-inline-start: 2px;
                padding-top: 8px;
            }
        }
    `,
};

styles.overflowMenuGridItem = {
    ...styles.overflowMenuGridItem,
    width: [9, 9, 0, 0, 0],
    css: css`
        ${styles.overflowMenuGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 2;
            justify-content: flex-end;
        }
    `,
};

styles.notesHidden = {
    ...styles.notesHidden,
    css: css`
        ${styles.notesHidden?.css}
        ${mediaQueriesBP.maxMD} {
            order: 4;

            & + div {
                & + div {
                    ${mediaQueriesBP.maxMD} {
                        order: 6;
                    }
                }
            }
        }
    `,
};

styles.priceAndAvailabilityGridItem = {
    ...styles.priceAndAvailabilityGridItem,
    width: [12, 12, 4, 4, 5],
    css: css`
        ${styles.priceAndAvailabilityGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 5;
        }
    `,
};

styles.notesGridItem = {
    ...styles.notesGridItem,
    width: 12,
    css: css`
        ${styles.notesGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 6;
        }
    `,
};

styles.buttonsGridItem = {
    ...styles.buttonsGridItem,
    width: [12, 12, 2, 2, 2],
    css: css`
        ${styles.buttonsGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            order: 7;
        }
    `,
};

styles.priceGridItem = {
    ...styles.priceGridItem,
    width: [12, 12, 12, 12, 5],
};

styles.productPriceStyles = {
    ...styles.productPriceStyles,
    priceLabelText: {
        ...styles.productPriceStyles?.priceLabelText,
        css: css`
            ${styles.productPriceStyles?.priceLabelText?.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
            }
        `,
    },
};

styles.uomAndQuantityGridItem = {
    ...styles.uomAndQuantityGridItem,
    width: [12, 12, 12, 12, 6],
};

styles.uomGridItem = {
    ...styles.uomGridItem,
    width: [6, 6, 6, 6, 6],
    printWidth: 6,
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    width: [6, 6, 6, 5, 5],
    printWidth: 6,
};

styles.CustomAvailabilityGridItem = {
    ...styles.CustomAvailabilityGridItem,
    css: css`
        ${mediaQueriesBP.maxMD} {
            display: none;
        }
    `,
};

styles.availabilityGridItem = {
    ...styles.availabilityGridItem,
    css: css`
        ${mediaQueriesBP.minMD} {
            display: none;
        }
    `,
};

styles.addToCartButton = {
    ...styles.addToCartButton,
    css: css`
        ${styles.addToCartButton?.css}
        min-height: 50px;
    `,
};

styles.productUnitOfMeasureSelectStyles = {
    ...styles.productUnitOfMeasureSelectStyles,
    cssOverrides: {
        ...styles.productUnitOfMeasureSelectStyles?.cssOverrides,
        inputSelect: css`
            min-height: 50px !important;

            & + span {
                min-height: 50px !important;
            }
        `,
    },
};

styles.productQuantityOrderedStyles = {
    ...styles.productQuantityOrderedStyles,
    cssOverrides: {
        ...styles.productQuantityOrderedStyles?.cssOverrides,
        inputSelect: css`
            min-height: 50px !important;
        `,
    },
};
